import { useState, useCallback } from "react";

export interface GeneratePayload { reportType: string; startDate: string; endDate: string }

export function useReportActions(opts?: {
    onGenerate?: (payload: GeneratePayload) => Promise<void> | void;
    onOpen?: () => void;
    onClose?: () => void;
}) {
    const [isOpen, setIsOpen] = useState(false);

    const openReport = useCallback(() => {
        setIsOpen(true);
        opts?.onOpen?.();
    }, [opts]);

    const closeReport = useCallback(() => {
        setIsOpen(false);
        opts?.onClose?.();
    }, [opts]);

    const handleGenerate = useCallback(async (payload: GeneratePayload) => {
        await opts?.onGenerate?.(payload);
        setIsOpen(false);
    }, [opts]);

    return { isOpen, openReport, closeReport, handleGenerate };
}
